import { isStag } from './isStag';

export const getMemberJWTTokenKey = async () => {
  const stag = await isStag();
  return stag ? 'ably-jwt-token-staging' : 'ably-jwt-token';
};

export const getAnonymousJWTTokenKey = async () => {
  const stag = await isStag();
  return stag ? 'ably-anonymous-token-staging' : 'ably-anonymous-token';
};
